import React from 'react';

const NumberOfVehiclesInHouseholdFilterIcon = (props: any) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <circle cx="4.9375" cy="13.5625" r="2.0625" strokeWidth="1.5" />
    <path
      d="M18 8.5L2.03307 7.97168C1.46813 7.95299 1 8.40589 1 8.97114V11C1 12.1046 1.89543 13 3 13V13"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.25 7.375L4.90627 4.8906C5.2772 4.3342 5.90166 4 6.57037 4H10.8308C11.3779 4 11.9011 4.22411 12.2786 4.62012L15.5 8"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M7.1875 13H11" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M13.3333 12.5H18.6666" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M13 15H18.3333" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M17.3334 11L16.6667 16.5" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M14.6667 11L14 16.5" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default NumberOfVehiclesInHouseholdFilterIcon;
